import {useContext} from "react";
import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import {isPhoneVisit, isRemoteVisit} from "../../../../../../utils/TimelineUtils";
import {TYPE_VIDEO_CONFERENCE} from "../../../../../../definitions/TimelineItems";


const TimelineFrameContentDetailsWrapper = ({children}) => {
    const { data, past } = useContext(TimelineFrameDataContext);

    if (data.type === TYPE_VIDEO_CONFERENCE && past) {
        return null;
    }

    if (isPhoneVisit(data)) {
        return null;
    }

    return (
        <>{children}</>
    )
}

export default TimelineFrameContentDetailsWrapper;